"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var s = _interopRequireWildcard(require("./styles"));

var _isCompleted = _interopRequireDefault(require("../utils/isCompleted"));

var _isFailedContent = _interopRequireDefault(require("../utils/isFailedContent"));

var _Progress = _interopRequireDefault(require("../components/Progress"));

var _ActionButton = _interopRequireDefault(require("../components/ActionButton"));

var _DueInfo = _interopRequireDefault(require("../components/DueInfo"));

var _Separator = _interopRequireDefault(require("../components/Separator"));

var _PathDetails = _interopRequireDefault(require("../components/PathDetails"));

var _BadgeCertificateInfo = _interopRequireDefault(require("../components/BadgeCertificateInfo"));

var _CompletedOn = _interopRequireDefault(require("../components/CompletedOn"));

var _ViewBadgeCertificate = _interopRequireDefault(require("../components/ViewBadgeCertificate"));

var _contentType = _interopRequireDefault(require("../utils/contentType"));

var _ContentImage = _interopRequireDefault(require("../components/ContentImage"));

var _Space = _interopRequireDefault(require("../components/Space"));

var _CloseIconSquareButton = _interopRequireDefault(require("../components/CloseIconSquareButton"));

var _AvailabiltyInfo = _interopRequireDefault(require("../components/AvailabiltyInfo"));

var _isPendingReview = _interopRequireDefault(require("../utils/isPendingReview"));

var _getContentTypeNames = _interopRequireDefault(require("../utils/getContentTypeNames"));

function getTopBarInfos(props) {
  var topInfos = [];
  var theme = props.theme,
      contentType = props.contentType,
      certificateInfo = props.certificateInfo,
      badgeInfo = props.badgeInfo,
      alternateContentType = props.alternateContentType;
  var completed = (0, _isCompleted.default)(props);
  topInfos.push(_react.default.createElement("div", {
    key: "contentType",
    className: s.contentType(theme)
  }, (0, _getContentTypeNames.default)(alternateContentType, contentType, 'u')));

  if (contentType === _contentType.default.Path) {
    topInfos.push(_react.default.createElement(_Separator.default, {
      key: topInfos.length
    }), _react.default.createElement(_PathDetails.default, (0, _extends2.default)({
      key: "pathDetails"
    }, props)));
  }

  if (!completed && badgeInfo) {
    topInfos.push(_react.default.createElement(_Separator.default, {
      key: topInfos.length
    }), _react.default.createElement(_BadgeCertificateInfo.default, (0, _extends2.default)({
      key: "badgeInfo"
    }, props, {
      type: "badge"
    })));
  }

  if (!completed && certificateInfo) {
    topInfos.push(_react.default.createElement(_Separator.default, {
      key: topInfos.length
    }), _react.default.createElement(_BadgeCertificateInfo.default, (0, _extends2.default)({
      key: "certificateInfo"
    }, props, {
      type: "certificate"
    })));
  } // if (showCloseIconButton) {
  //   topInfos.push(
  //     <div className={s.closeIconButton}>
  //       <CloseIconButton onCloseIconButton={onCloseIconButton} size="16px" />
  //     </div>
  //   );
  // }


  return topInfos;
}

function getBottomBarInfos(props) {
  var certificateInfo = props.certificateInfo,
      badgeInfo = props.badgeInfo,
      dontRenderSideInfo = props.dontRenderSideInfo,
      isNotAvailable = props.isNotAvailable,
      availableOn = props.availableOn,
      onCloseIconButton = props.onCloseIconButton,
      showCloseIconButton = props.showCloseIconButton;
  var bottomInfos = [];
  var completed = (0, _isCompleted.default)(props);
  var isFailed = (0, _isFailedContent.default)(props);
  var pendingReview = (0, _isPendingReview.default)(props);

  if (isNotAvailable) {
    bottomInfos.push(_react.default.createElement(_AvailabiltyInfo.default, {
      availableOn: availableOn
    }));
    return bottomInfos;
  }

  if (!completed) {
    var ProgressNode = !dontRenderSideInfo && (0, _Progress.default)(props, 'progress');

    if (ProgressNode) {
      bottomInfos.push(_react.default.createElement(_Space.default, {
        key: bottomInfos.length,
        width: 28
      }), ProgressNode);
    }

    var DueInfoNode = !dontRenderSideInfo && (0, _DueInfo.default)(props, 'dueInfo');

    if (DueInfoNode) {
      bottomInfos.push(_react.default.createElement(_Space.default, {
        key: bottomInfos.length,
        width: 28
      }), DueInfoNode);
    }

    if (showCloseIconButton) {
      bottomInfos.push(_react.default.createElement("div", {
        style: {
          marginRight: '-20px'
        }
      }, _react.default.createElement(_CloseIconSquareButton.default, {
        onCloseIconButton: onCloseIconButton,
        size: "16px"
      })));
    }

    var ActionButtonNode = !dontRenderSideInfo && (0, _ActionButton.default)(props, 'actionButton');

    if (ActionButtonNode) {
      bottomInfos.push(_react.default.createElement(_Space.default, {
        key: bottomInfos.length,
        width: 28
      }), ActionButtonNode);
    }
  } else {
    if (!dontRenderSideInfo && !isFailed && certificateInfo && !pendingReview) {
      bottomInfos.push(_react.default.createElement(_Space.default, {
        key: bottomInfos.length,
        width: 28
      }), _react.default.createElement(_ViewBadgeCertificate.default, (0, _extends2.default)({
        key: "viewCertificate"
      }, props, {
        type: "certificate"
      })));
    }

    if (!dontRenderSideInfo && !isFailed && badgeInfo && !pendingReview) {
      bottomInfos.push(_react.default.createElement(_Space.default, {
        key: bottomInfos.length,
        width: 28
      }), _react.default.createElement(_ViewBadgeCertificate.default, (0, _extends2.default)({
        key: "viewBadge"
      }, props, {
        type: "badge"
      })));
    }

    !dontRenderSideInfo && bottomInfos.push(_react.default.createElement(_Space.default, {
      key: bottomInfos.length,
      width: 28
    }), _react.default.createElement(_CompletedOn.default, (0, _extends2.default)({
      key: "completedOn"
    }, props)));
  }

  return bottomInfos;
}

function ContentCardWide(props) {
  var theme = props.theme,
      name = props.name,
      contentId = props.contentId,
      className = props.className,
      CustomComponent = props.customOption;
  var topBarInfos = getTopBarInfos(props);
  var bottomBarInfos = getBottomBarInfos(props);
  return _react.default.createElement("div", {
    key: contentId,
    className: (0, _classnames.default)(s.root(theme), className)
  }, _react.default.createElement(_ContentImage.default, (0, _extends2.default)({}, props, {
    height: 60,
    width: 60,
    badgeIconSize: 20,
    className: s.contentImage
  })), _react.default.createElement("div", {
    className: s.contentInfo
  }, _react.default.createElement("div", {
    className: s.topInfo
  }, topBarInfos), _react.default.createElement("div", {
    className: s.bottomInfo
  }, _react.default.createElement("div", {
    title: name,
    className: s.name(theme)
  }, name), _react.default.createElement("div", {
    className: s.bottomSideInfo
  }, bottomBarInfos)), CustomComponent && _react.default.createElement("div", {
    className: s.customComponent
  }, " ", _react.default.createElement(CustomComponent, null), " ")));
}

var _default = (0, _emotionTheming.withTheme)(ContentCardWide);

exports.default = _default;